import {Component} from '@angular/core';

@Component({
  selector: 'hv-logo',
  standalone: true,
  template: `
    <div class="logo-wrapper" aria-label="Powered by Hoomvip">
      <img src="/images/powered-by.png"/>
    </div>
  `,
  styles: [`
    .logo-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
    }
    img {
      width: 84px;
      height: auto;
    }
  `]
})
export class HoomvipLogoComponent {
}
